import {
    // Constants
    USERS_CHANGED,
    USER_ADDED,
    USERS_ADDED,

    // Actions
    setUsers,
    resetUsers,
    logIn,
    // logOut,
    // togglePinnedForUser,
    // toggleMultistartForUser,
    setUserTokens,
    setUserProfile,
    // setServerOrder,

    // Selectors
    getTokens,
    getActiveOrder,
    getUserAccessToken,
    getUserRefreshToken,
    // getUserProfile,
    getActiveUserProfile,
    // isUserPinned,
    // shouldUserMultiStart,
    // shouldUserAutoLaunch,
    // getActiveMultiStart,
} from './data'

// Reducer is exposed so that we can hook up the state
export { default as usersReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Constants are exposed as a way for feature to send out information
// Way for the feauture to inform the surroundings of something that has happened
export const constants = {
    USERS_CHANGED, // LocalForageMiddleware
    USER_ADDED, // LauncherCommandMiddleware
    USERS_ADDED, // LauncherCommandMiddleware
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    setUsers, // Localforage
    resetUsers, // LogoutMiddleware
    logIn, // LoginWindow, Backend
    // logOut, // User
    // togglePinnedForUser, // User,
    // toggleMultistartForUser, // User
    setUserTokens, // Eula
    setUserProfile, // ProfileSelector
    // setServerOrder, // UserList
}

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    getTokens, // Backend
    getActiveLoggedInUserIds: getActiveOrder, // LauncherCommandMiddleware, Dashboard, User
    getUserAccessToken, // Eula
    getUserRefreshToken, // Eula
    getActiveUserProfile, // LaunchFrame, ProfileSelector
    // isUserPinned, // User
    // shouldUserMultiStart, // User
    // shouldUserAutoLaunch, // User
    // getActiveMultiStart, // UserList
    // getActiveUserOrder: getActiveOrder, // UserList
}



// WEBPACK FOOTER //
// ./src/features/Users/exports.js